export const inputs = [
    {
        columns: [
            {
                type: "checkbox",
                id: "mention",
                name: "mention",
                label: "Pokaži mi tko me je spomenio",
                required: false,
                value: true,
            },
            {
                type: "checkbox",
                id: "comeBack",
                name: "comeBack",
                label: "Pokaži mi što je novo",
                required: false,
                value: true,
            },
            {
                type: "checkbox",
                id: "follow",
                name: "follow",
                label: "Pokaži mi pratitelje",
                required: false,
                value: true,
            },
            {
                type: "checkbox",
                id: "comments",
                name: "comments",
                label: "Pokaži mi komentare",
                required: false,
                value: true,
            },
            {
                type: "checkbox",
                id: "favorites",
                name: "favorites",
                label: "Pokaži mi tko me sprema u omiljene",
                required: false,
                value: true,
            },
            {
                type: "checkbox",
                id: "imagesOfOthers",
                name: "imagesOfOthers",
                label: "Pokaži mi kako je drugimo ispalo",
                required: false,
                value: true,
            },
            {
                type: "checkbox",
                id: "newContent",
                name: "newContent",
                label: "Pokaži mi nov sadržaj",
                required: false,
                value: true,
            },
            {
                type: "checkbox",
                id: "trophy",
                name: "trophy",
                label: "Pokaži mi novi trofej",
                required: false,
                value: true,
            },
            {
                type: "checkbox",
                id: "prifileUpdate",
                name: "prifileUpdate",
                label: "Daj mi da popunim taj profil do kraja",
                required: false,
                value: true,
            },
            {
                type: "checkbox",
                id: "birthday",
                name: "birthday",
                label: "Da, želim svoj dar",
                required: false,
                value: true,
            },
        ],
    },
];
